<template>
    <VueSlickCarousel
        class="header-slider"
        v-bind:class="textafterbanner ? 'text-after-banner' : ''"
        v-bind="slickSettings"
        ref="header-carousel"
        v-if="total > 0"
        @beforeChange="openClosePlayer"
    >
        <div class="header" v-if="item.enabled" v-for="(item, index) in items"
             @mouseover="hover = true"
             @mouseleave="hover = false"
        >

          <a v-if="item.href !== null" :href="item.href" :target="item.target || '_blank'" class="full-size-link"></a>

          <youtube-player
                v-if="item.youtube !== '' && item.youtube !== undefined && item.youtube !== null "
                :video-id='item.youtube'
                :show-player="total > 1 ? item.showPlayer : true"
            ></youtube-player>

            <div class="slide-content-image" v-if="item.youtube === '' || item.youtube === undefined || item.youtube === null ">

              <div class="content-area "
                   :class="'position-' + item.contentPosition + ' ' + item.size"
                   :style="{
                   width: (100 / totalOfPositions) * (item.size === 'double' ? 2 : 1) + '%',
                   left: ((100 / totalOfPositions ) * item.contentPosition) + '%'
                 }"
              >
                <div class="caption" v-html="item.label"></div>
                <a v-if="item.href !== null && !item.hide_button" :href="item.href" :target="item.target || '_blank'" class="btn btn-success" v-text="item.readMore || readmore"></a>
              </div>
              <div class="image-area" v-if="item.image_url" v-lazy:background-image="item.image_url"></div>

            </div>
        </div>
    </VueSlickCarousel>
</template>

<script>
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

    export default {
        components: { VueSlickCarousel },
        props: ['items', 'settings', 'readmore', 'numberofpositions', 'textafterbanner'],

        data: () => { return {
            currentFilter : '',
            totalOfPositions: 4,
            total: 0,
            hover: false,
            activeSlideIndex: 0,
            slickSettings: {
                dots:true,
                arrows:true,
                infinite:false,
                autoplay: false,
                speed:0,
                autoplaySpeed: 0,
                variableWidth:false,
                adaptiveHeight: false,
                draggable: true,
                slidesToShow : 1,
                pauseOnFocus: true,
                responsive: [
                  {
                    breakpoint: 768,
                    settings: {
                      dots: true
                    }
                  }
                ]
            }
        }},

        beforeMount() {

          let self = this;
          this.totalOfPositions = parseInt(this.numberofpositions);
          Object.keys(this.settings).forEach((key)=>{
            self.slickSettings[key] = self.settings[key];
          });

          Object.keys(this.items).forEach((index)=>{
              self.items[index].contentPosition = self.items[index].contentPosition === undefined ? 0 : self.items[index].contentPosition;
              self.total += self.items[index].enabled ? 1 : 0;
              self.items[index].showPlayer = false;
          });

        },

        mounted(){
          this.recalculateDotHeight();
        },

        watch: {
          hover: function (e) {
            if(this.items[this.activeSlideIndex] !== undefined) {
              this.items[this.activeSlideIndex]['showPlayer'] = true;
              this.$forceUpdate();
            }
          }
        },

        methods:{
            recalculateDotHeight: function() {
                $(this.$el)
                    .find('.slick-dots')
                    .css('height', (this.total * 13) + ((this.total - 1) * 18));
            },
            openClosePlayer: function(oldIndex,newIndex) {
              if (this.items[oldIndex] !== undefined) {
                this.items[oldIndex]['showPlayer'] = false;
                this.items[newIndex]['showPlayer'] = true;
                //this.activeSlideIndex = newIndex;
                this.$forceUpdate();
              }
            }
        },
    }
</script>
